import $ from 'jquery';

export default class TogglePanel {
    init() {
        $(document).ready(() => { this.setup(); });
    }

    setup() {
        let $toggleContoller = $('.jbg-toggle-panel');
        let $open = $toggleContoller.find('[data-open]');
        let $close = $toggleContoller.find('[data-close]');
        let $content = $toggleContoller.find('[data-content]');
        $close.hide();
        $content.hide();

        $open.on('click', function() {
            $open.hide();
            $close.show();
            $content.show('fast');
        });

        $close.on('click', function() {
            $close.hide();
            $open.show();
            $content.hide('fast');
        });
    }
}